import React from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Skeleton from '@material-ui/lab/Skeleton';

// STYLES
import { Container } from './styles';

const SectionSkeleton = props => {
  const downXs = useMediaQuery(({ breakpoints }) => breakpoints.down('xs'));
  const height = downXs ? 104 : 138;

  return (
    <Container {...props} className="section-skeleton">
      <Skeleton className="m-b-15" width={275} height={36} variant="rect" />
      <Skeleton className="m-b-15" width="100%" height={height} variant="rect" />
      <Skeleton className="m-b-15" width="100%" height={height} variant="rect" />
      <Skeleton className="m-b-15" width="100%" height={height} variant="rect" />
      <Skeleton className="m-b-15" width="100%" height={height} variant="rect" />
    </Container>
  );
};

export default React.memo(SectionSkeleton);
